import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {sidebarMenu_template} from "../templates/sidebarMenu_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { amCharts_v4_date_basic_template } from "./amCharts_v4_date_basic_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { exportDataCsv } from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class accountApi_template extends vnTemplate{

    protected sidebarMenu: sidebarMenu_template;
    protected presetFilter: presetFilter_template;

    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Usage Stats</h2>
        </div>

        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div id="accountApi-results" class="nav-page-content">
                    <div class="block-default variation">
                        <div class="w-justify full-width">
                            <div class="w-left w-form">
                                <div class="form-body form-body-header">
                                    <div class="form-group">
                                        <span class="form-sub-title">
                                            Account API
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <p class="form-text">
                                            Manage your account API key
                                        </p>
                                    </div>
                                    <div class="form-group">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ko if: isLoaded() -->
                        <div class="w-form w-form-large">
                            <div class="form-header" style="height: 2rem;">

                            </div>

                            <div class="w-form-body">
                                <div class="form-body">
                                    <span class="form-sub-title">Manage API Key</span>
                                    <div class="form-group row row-left">
                                        <label class="form-label">Key Activation</label>
                                        <label class="display-toggle-container">
                                            <input type="checkbox" class="display-toggle-input" data-bind="event: {change: onEnableApiKey}, checked: apiKeyEnabled() == 1 ? true : false">
                                            <span class="display-toggle-slider">
                                                <span class="toggle-on">ON</span>
                                                <span class="toggle-off">OFF</span>
                                            </span>
                                        </label>

                                    </div>

                                    <!-- ko if: apiKeyEnabled() == 1 -->

                                        <div class="form-group">
                                            <hr class="form-hr">
                                        </div>

                                        <!-- API Key section -->
                                        <div class="form-group" data-bind="visible: apiKey">
                                            <label class="form-label">API Key</label>
                                            <input type="text" class="input-text" data-bind="value: apiKey, attr: { readonly: true }" readonly>
                                        </div>

                                        <div class="form-group row row-left">
                                            <button class="button-default icon i-copy" data-bind="click: copyApiKeyToClipboard">copy key</button>
                                            <button class="button-default icon i-refresh" data-bind="text: apiKey() ? 'Regenerate Key' : 'Generate Key', click: apiKey() ? onRegenerateApiKey : onGenerateApiKey">Regenerate Key</button>
                                        </div>

                                    <!-- /ko -->

                                </div>
                                <div class="form-body">
                                    <span class="form-sub-title">Example Schema</span>
                                    <div class="form-group block-filters">
                                        <span class="code">
                                            <pre>
                                                <code data-bind="text: apiCode()"></code>
                                            </pre>
                                        </span>
                                        <button class="button-default icon i-copy" data-bind="click: copyApiCodeToClipboard" style="text-transform:capitalize !important">copy code</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- /ko -->

                </div>
            </div>
        </div>
        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>

        <!-- ko if: isWarningMessage() -->
            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isWarningMessage()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Warning</h3>
                            <button type="button" data-bind="event: { click: onCloseWarning }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This will void your current API key. Are you sure you want to regenerate it?</p>
                                <button class="button-default icon i-copy" data-bind="click: copyApiKeyToClipboard">copy key</button>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="click: onSubmitRegenerate" type="button" class="btn highlight">Close</button>
                        </div>
                    </div>

                </div>
            </div>
        <!-- /ko -->

        `;
    }

    protected initPartial(): void {

        const now = new Date();
        now.setHours(0,0,0,0);
        const last7Days = new Date(now);
        last7Days.setDate(now.getDate() - 7);

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-api');

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('accountApi');
    }

    protected getTemplateName(): string{

        return "accountApi-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return ["page-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            isLoaded: ko.observable(false),
            apiKey: ko.observable(null),
            apiKeyEnabled: ko.observable(null),
            apiCode: ko.observable(''),
            isWarningMessage: ko.observable(false),
            selectedDataParams: ko.observable(null),
            apiLogTableData: ko.observable([]),
            apiLogGraphData: ko.observable([]),
            tableOrdering: ko.observable({ col: null, dir: null }),
            apiLogsExportData: ko.observable([]),
            copyApiKeyToClipboard: function(){
                self.copyApiKeyToClipboard();
            },
            copyApiCodeToClipboard: function(){
                self.copyApiCodeToClipboard();
            },
            openSidebar: function(){
                self.openSidebar();
            },
            onCloseWarning: function(){
                self.onCloseWarning();
            },
            onSubmitRegenerate: function(){
                self.onSubmitRegenerate();
            },
            onEnableApiKey: function(){
                self.caller.onEnableApiKey();
            },
            onGenerateApiKey: function(){
                self.onGenerateApiKey();
            },
            onRegenerateApiKey: function(){
                self.onRegenerateApiKey();
            },
        };
    }

    private onCloseWarning(){

        this.getTemplateViewModel().isWarningMessage(false);
    }

    private onSubmitRegenerate() {

        this.caller.onGenerateApiKey();
        this.getTemplateViewModel().isWarningMessage(false);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    public setApiKey(apiKey){

        this.getTemplateViewModel().apiKey(apiKey);
    }

    public setIsLoaded(){

        this.getTemplateViewModel().isLoaded(true);
    }

    public setApiKeyEnabled(apiKeyEnabled){

        this.getTemplateViewModel().apiKeyEnabled(apiKeyEnabled);
    }

    public setApiCode(apiCode){

        this.getTemplateViewModel().apiCode(apiCode);
    }

    public setSideMenuPermissionsData(permissions){

        this.sidebarMenu.setData(permissions);
    }

    private onGenerateApiKey() {

        this.caller.onGenerateApiKey();
    }

    private onRegenerateApiKey() {

        this.getTemplateViewModel().isWarningMessage(true);
    }

    private copyApiKeyToClipboard() {

        const apiKey = this.getTemplateViewModel().apiKey();

        navigator.clipboard.writeText(apiKey);
        this.caller.copyToClipboardNotification();
    }

    private copyApiCodeToClipboard() {

        const apiCode = this.getTemplateViewModel().apiCode();

        navigator.clipboard.writeText(apiCode);
        this.caller.copyToClipboardNotification();
    }    

    //
    // implementation of base class [vnTemplate] billingPeriodId
    public getViewModelForRequest(){

        return {

            filters: {
                apiKeyEnabled: this.getTemplateViewModel().apiKeyEnabled(),
            }
        }
    }

    public setViewModelFromRequest(params : Array<any>): void {

        //set the observables
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/accountApi_template.ts